import React from "react";

const SectionNav = ({ isOpen, items, activeId, onLinkClick }) => {
  const handleClick = (id, e) => {
    if (onLinkClick) onLinkClick(id, e);
  };
  return (
    <nav
      className={`abr-section-nav${isOpen ? " is-open" : ""}`}
      id="abr-section-nav"
      aria-label="Report sections"
      aria-hidden={isOpen ? "false" : "true"}
    >
      <div className="abr-nav-eyebrow">Report</div>
      <ol>
        {items.map((item) =>
          item.hidden ? null : (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                data-target={item.id}
                className={activeId === item.id ? "is-active" : ""}
                onClick={(e) => handleClick(item.id, e)}
              >
                {item.label}
              </a>
            </li>
          )
        )}
      </ol>
    </nav>
  );
};

export default SectionNav;
